
(() => {
  const SUPABASE_URL = "https://almfqcwuyhrgljfzziuc.supabase.co";
  const TRACKING_API = SUPABASE_URL + "/functions/v1/track-event";
  const GET_SESSION_API = SUPABASE_URL + "/functions/v1/get-tracking-session";
  const FINGERPRINT_KEY = "_lv_fingerprint";
  const SESSION_CACHE_KEY = "_sf_session_data";

  console.log("[Conversion Tracker] Inicializando...");

  // Fingerprint generation (must match vitrine script exactly)
  function getCanvasFingerprint() {
    try {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) return null;
      canvas.width = 200;
      canvas.height = 50;
      ctx.textBaseline = "top";
      ctx.font = "14px Arial";
      ctx.fillStyle = "#f60";
      ctx.fillRect(125, 1, 62, 20);
      ctx.fillStyle = "#069";
      ctx.fillText("ShopFlow", 2, 15);
      ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
      ctx.fillText("Tracking", 4, 17);
      return canvas.toDataURL().slice(-50);
    } catch { return null; }
  }

  function getWebGLFingerprint() {
    try {
      const canvas = document.createElement("canvas");
      const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      if (!gl) return null;
      const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
      if (!debugInfo) return null;
      return gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) + "~" + gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
    } catch { return null; }
  }

  function getFontsFingerprint() {
    try {
      const baseFonts = ["monospace", "sans-serif", "serif"];
      const testFonts = ["Arial", "Verdana", "Times New Roman", "Courier New", "Georgia", "Comic Sans MS"];
      const testString = "mmmmmmmmmmlli";
      const testSize = "72px";
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) return null;
      const detected = [];
      for (const font of testFonts) {
        for (const baseFont of baseFonts) {
          ctx.font = testSize + " " + baseFont;
          const baseWidth = ctx.measureText(testString).width;
          ctx.font = testSize + " '" + font + "', " + baseFont;
          if (baseWidth !== ctx.measureText(testString).width) { detected.push(font); break; }
        }
      }
      return detected.join(",");
    } catch { return null; }
  }

  function generateFingerprint() {
    return {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      screenResolution: screen.width + "x" + screen.height,
      colorDepth: screen.colorDepth,
      platform: navigator.platform,
      language: navigator.language,
      cookieEnabled: navigator.cookieEnabled,
      doNotTrack: navigator.doNotTrack,
      hardwareConcurrency: navigator.hardwareConcurrency,
      deviceMemory: navigator.deviceMemory,
      touchPoints: navigator.maxTouchPoints,
      canvasHash: getCanvasFingerprint(),
      webglHash: getWebGLFingerprint(),
      fontsHash: getFontsFingerprint()
    };
  }

  async function generateFingerprintHash() {
    const fp = generateFingerprint();
    const fpString = JSON.stringify(fp);
    try {
      const encoder = new TextEncoder();
      const data = encoder.encode(fpString);
      const hashBuffer = await crypto.subtle.digest("SHA-256", data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
    } catch {
      let hash = 0;
      for (let i = 0; i < fpString.length; i++) {
        hash = ((hash << 5) - hash) + fpString.charCodeAt(i);
        hash = hash & hash;
      }
      return "fp_" + Math.abs(hash).toString(36);
    }
  }

  // Deobfuscate param: reverse + base64 decode (for legacy URL params)
  function deobfuscateParam(value) {
    try {
      var reversed = value.split("").reverse().join("");
      return decodeURIComponent(atob(reversed));
    } catch { return null; }
  }

  // Try to get tracking params from server via fingerprint (primary method)
  async function getTrackingFromServer() {
    try {
      // Check cache first
      const cached = sessionStorage.getItem(SESSION_CACHE_KEY);
      if (cached) {
        const data = JSON.parse(cached);
        if (data.storePairId && data.customerId) {
          console.log("[Conversion Tracker] Usando sessão em cache");
          return data;
        }
      }

      const fpHash = await generateFingerprintHash();
      console.log("[Conversion Tracker] Buscando sessão via fingerprint:", fpHash.substring(0, 16) + "...");

      const response = await fetch(GET_SESSION_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fingerprint_hash: fpHash })
      });

      if (response.ok) {
        const result = await response.json();
        if (result.success) {
          const sessionData = {
            storePairId: result.store_pair_id,
            customerId: result.customer_id,
            sessionId: result.session_id,
            source: result.vitrine_domain,
            productHandle: result.product_handle,
            flowId: result.flow_id,
            clickIds: result.click_ids || {},
            trackingParams: result.tracking_params || {},
            gclid: result.click_ids?.gclid,
            fbclid: result.click_ids?.fbclid,
            ttclid: result.click_ids?.ttclid,
            msclkid: result.click_ids?.msclkid,
            utmSource: result.tracking_params?.utm_source,
            utmMedium: result.tracking_params?.utm_medium,
            utmCampaign: result.tracking_params?.utm_campaign
          };

          // Cache for future use
          sessionStorage.setItem(SESSION_CACHE_KEY, JSON.stringify(sessionData));
          console.log("[Conversion Tracker] ✅ Sessão recuperada do servidor");
          return sessionData;
        }
      }
    } catch (e) {
      console.warn("[Conversion Tracker] Erro ao buscar sessão do servidor:", e);
    }
    return null;
  }

  // Get tracking parameters from URL (legacy fallback)
  function getTrackingFromUrl() {
    var params = new URLSearchParams(window.location.search);
    
    // Check for obfuscated params first (_sf contains all ShopFlow data)
    var sfData = params.get("_sf");
    if (sfData) {
      try {
        var decoded = deobfuscateParam(sfData);
        if (decoded) {
          var data = JSON.parse(decoded);
          return {
            storePairId: data.spid,
            customerId: data.cid,
            sessionId: data.sid,
            source: data.src,
            gclid: params.get("gclid"),
            fbclid: params.get("fbclid"),
            ttclid: params.get("ttclid"),
            msclkid: params.get("msclkid"),
            utmSource: params.get("utm_source"),
            utmMedium: params.get("utm_medium"),
            utmCampaign: params.get("utm_campaign")
          };
        }
      } catch (e) {
        console.warn("[Conversion Tracker] Erro ao decodificar _sf:", e);
      }
    }
    
    // Fallback to legacy params (backwards compatibility)
    return {
      storePairId: params.get("_spid"),
      customerId: params.get("_cid"),
      source: params.get("checkout_redirect_source"),
      gclid: params.get("gclid"),
      fbclid: params.get("fbclid"),
      ttclid: params.get("ttclid"),
      msclkid: params.get("msclkid"),
      utmSource: params.get("utm_source"),
      utmMedium: params.get("utm_medium"),
      utmCampaign: params.get("utm_campaign")
    };
  }

  // Get tracking params: try server-side first (fingerprint), then URL params
  async function getTrackingParams() {
    // Method 1: Server-side via fingerprint (preferred, 100% clean URL)
    const serverParams = await getTrackingFromServer();
    if (serverParams && serverParams.storePairId && serverParams.customerId) {
      return serverParams;
    }

    // Method 2: URL params (legacy fallback)
    const urlParams = getTrackingFromUrl();
    if (urlParams.storePairId && urlParams.customerId) {
      console.log("[Conversion Tracker] Usando parâmetros da URL (fallback)");
      return urlParams;
    }

    // Method 3: Check session storage
    try {
      const stored = sessionStorage.getItem("_conversion_tracking");
      if (stored) return JSON.parse(stored);
    } catch {}

    return urlParams; // Return whatever we have
  }

  // Get stored params (from any source)
  function getStoredParams() {
    try {
      const stored = sessionStorage.getItem(SESSION_CACHE_KEY) || sessionStorage.getItem("_conversion_tracking");
      if (stored) return JSON.parse(stored);
    } catch {}
    return null;
  }

  // Detect source platform
  function detectPlatform(params) {
    if (params.gclid || params.clickIds?.gclid) return "google_ads";
    if (params.fbclid || params.clickIds?.fbclid) return "facebook";
    if (params.ttclid || params.clickIds?.ttclid) return "tiktok";
    if (params.msclkid || params.clickIds?.msclkid) return "bing";
    if (params.utmSource) return params.utmSource.toLowerCase();
    return "organic";
  }

  // Get click ID
  function getClickId(params) {
    return params.gclid || params.fbclid || params.ttclid || params.msclkid || 
           params.clickIds?.gclid || params.clickIds?.fbclid || 
           params.clickIds?.ttclid || params.clickIds?.msclkid || null;
  }

  // Store params in sessionStorage for thank you page
  async function storeParams() {
    const params = await getTrackingParams();
    if (params && params.storePairId && params.customerId) {
      try {
        sessionStorage.setItem("_conversion_tracking", JSON.stringify(params));
        console.log("[Conversion Tracker] Params armazenados:", Object.keys(params).length, "campos");
      } catch (e) {
        console.warn("[Conversion Tracker] Falha ao armazenar params:", e);
      }
    }
  }

  // Send conversion event
  async function sendConversionEvent(orderData = {}) {
    // Try stored params first, then fetch from server
    let params = getStoredParams();
    if (!params || !params.storePairId) {
      params = await getTrackingParams();
    }
    
    if (!params || !params.storePairId || !params.customerId) {
      console.log("[Conversion Tracker] Sem params de tracking, ignorando conversão");
      return;
    }

    try {
      const eventData = {
        customer_id: params.customerId,
        store_pair_id: params.storePairId,
        event_type: "conversion",
        source_platform: detectPlatform(params),
        click_id: getClickId(params),
        vitrine_domain: params.source || null,
        checkout_domain: window.location.hostname,
        user_agent: navigator.userAgent,
        cart_value: orderData.totalPrice || null,
        currency: orderData.currency || "BRL",
        product_handle: orderData.productHandles || params.productHandle || null,
        flow_id: params.flowId || null,
        session_id: params.sessionId || null
      };

      const response = await fetch(TRACKING_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(eventData)
      });

      if (response.ok) {
        console.log("[Conversion Tracker] ✅ Conversão enviada com sucesso!");
        // Clear stored params after successful conversion
        sessionStorage.removeItem("_conversion_tracking");
        sessionStorage.removeItem(SESSION_CACHE_KEY);
      } else {
        console.warn("[Conversion Tracker] Falha ao enviar conversão:", await response.text());
      }
    } catch (e) {
      console.warn("[Conversion Tracker] Erro ao enviar conversão:", e);
    }
  }

  // Check if we're on thank you / order confirmation page
  function isThankYouPage() {
    const path = window.location.pathname.toLowerCase();
    return path.includes("/thank_you") || 
           path.includes("/thank-you") || 
           path.includes("/orders/") ||
           path.includes("/checkouts/") && path.includes("/thank_you");
  }

  // Extract order data from Shopify's window object
  function extractOrderData() {
    try {
      // Shopify exposes order data on thank you page
      if (window.Shopify && window.Shopify.checkout) {
        const checkout = window.Shopify.checkout;
        return {
          totalPrice: checkout.total_price ? parseFloat(checkout.total_price) : null,
          currency: checkout.currency || "BRL",
          orderId: checkout.order_id,
          productHandles: checkout.line_items?.map(item => item.handle || item.product_title).join(",") || null
        };
      }
      
      // Alternative: try to get from ShopifyAnalytics
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
        const page = window.ShopifyAnalytics.meta.page;
        if (page.pageType === "thankYou" || page.pageType === "order") {
          return {
            totalPrice: page.totalPrice ? parseFloat(page.totalPrice) : null,
            currency: page.currency || "BRL",
            orderId: page.resourceId
          };
        }
      }
    } catch (e) {
      console.warn("[Conversion Tracker] Erro ao extrair dados do pedido:", e);
    }
    return {};
  }

  // Initialize tracking
  async function init() {
    // Always store params when landing on checkout pages (fetch from server if needed)
    await storeParams();

    // Check if we're on thank you page
    if (isThankYouPage()) {
      console.log("[Conversion Tracker] Página de confirmação detectada!");
      
      // Wait a bit for Shopify to populate order data
      setTimeout(async () => {
        const orderData = extractOrderData();
        console.log("[Conversion Tracker] Dados do pedido:", orderData);
        await sendConversionEvent(orderData);
      }, 1000);
    }
  }

  // Run on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  // Also listen for SPA navigation (some Shopify themes use this)
  const observer = new MutationObserver(() => {
    if (isThankYouPage()) {
      setTimeout(async () => {
        const orderData = extractOrderData();
        await sendConversionEvent(orderData);
      }, 1000);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  console.log("[Conversion Tracker] ✅ Carregado com sucesso (modo fingerprint server-side)!");
})();
